import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { createNote, uploadFile } from '../api';

const Dashboard = () => {
  const navigate = useNavigate();
  const [quickNote, setQuickNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleQuickNote = async () => {
    if (!quickNote.trim()) return;

    setSaving(true);
    try {
      await createNote(quickNote);
      setQuickNote('');
      navigate('/notes');
    } catch (err) {
      console.error('Failed to create note:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleQuickUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    setUploading(true);
    try {
      for (const file of files) {
        await uploadFile(file);
      }
      navigate('/files');
    } catch (err) {
      console.error('Failed to upload file:', err);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        {/* Quick Note */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              <NoteAddIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Quick Note
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={quickNote}
              onChange={(e) => setQuickNote(e.target.value)}
              placeholder="Type a quick note..."
              sx={{ mb: 2 }}
            />
            <Button
              variant="contained"
              onClick={handleQuickNote}
              disabled={saving || !quickNote.trim()}
            >
              {saving ? 'Saving...' : 'Save Note'}
            </Button>
          </Paper>
        </Grid>

        {/* Quick Upload */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              <CloudUploadIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Quick Upload
            </Typography>
            <Paper
              component="label"
              sx={{
                p: 4,
                textAlign: 'center',
                border: '2px dashed',
                borderColor: 'grey.300',
                bgcolor: 'background.paper',
                cursor: 'pointer',
                display: 'block',
                boxShadow: 'none',
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: 'action.hover',
                },
              }}
            >
              <CloudUploadIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
              <Typography color="textSecondary">
                {uploading ? 'Uploading...' : 'Click to select files'}
              </Typography>
              <input
                type="file"
                hidden
                multiple
                onChange={handleQuickUpload}
                disabled={uploading}
              />
            </Paper>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
